import { RouterProvider } from 'react-router-dom'
import { ContainerProvider } from '@/presentation/providers/ContainerProvider'
import { AuthProvider } from '@/presentation/providers/AuthProvider'
import { ThemeProvider } from '@/presentation/providers/ThemeProvider'
import { RuntimeConfigProvider } from '@/presentation/providers/RuntimeConfigProvider'
import { AppInitializer } from '@/presentation/components/AppInitializer'
import { AuthDebug } from '@/presentation/components/AuthDebug'
import { UnderMaintenance } from '@/presentation/components/ui/under-maintenance'
import { Toaster } from '@/presentation/components/ui/sonner'
import { router } from '@/presentation/routes'
import { ErrorBoundary } from '@/presentation/components/ui/ErrorBoundary'
import { configService } from '@/core/services/ConfigService'

function App() {
  return (
    <ErrorBoundary>
      <RuntimeConfigProvider>
        <AppContent />
      </RuntimeConfigProvider>
    </ErrorBoundary>
  )
}

function AppContent() {
  // Check if maintenance mode is enabled via unified configuration
  const isMaintenanceMode = configService.isMaintenanceMode()

  // Check if debug mode is enabled via unified configuration
  const isDebugMode = configService.isDebugMode()

  // If maintenance mode is enabled, show maintenance page
  if (isMaintenanceMode) {
    return (
      <ThemeProvider>
        <UnderMaintenance />
      </ThemeProvider>
    )
  }

  return (
    <AppInitializer>
      <ThemeProvider>
        <ContainerProvider>
          <AuthProvider>
            <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
              <RouterProvider router={router} />
              {/* Debug component - only show when debug mode is enabled */}
              {isDebugMode && <AuthDebug />}
              <Toaster />
            </div>
          </AuthProvider>
        </ContainerProvider>
      </ThemeProvider>
    </AppInitializer>
  )
}

export default App
